import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import '@/assets/styles/geral.css'
import '@fortawesome/fontawesome-free'
import '@fortawesome/fontawesome-free/css/all.css'

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.bundle.js';

import 'primeicons/primeicons.css'


const app = createApp(App);
app.use(PrimeVue, {
	theme: {
		preset: Aura
	}
});

app.use(router).mount('#app')
